import { GridBaseDataProvider } from '../../../grid/GridBaseDataProvider';
import { Column, ColumnKeys, GetDataGridItemsResponse, SetFiltersRequest, Status, Type } from '../types';
import {
  ColumnDetails,
  GetRowsRequest,
  GetSummaryRequest,
  GetSummaryResponse,
  UpdateSettingsRequest,
  UpdateSettingsResponse,
} from '../../../grid/types/common';
import { sanitizeObject } from '../../../utils/sanitization.utils';
import { getRequestDefaultOptions } from '../../../utils/request.utils';

export class MaintenanceWindowGridDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  response: any;

  constructor(public dependencies: any, private allColumnDetails: Array<ColumnDetails<Column, ColumnKeys>>) {
    super();
  }

  async getSummary(request: GetSummaryRequest<ColumnKeys>): Promise<GetSummaryResponse> {
    const companyId = this.dependencies.getActiveCompany().companyId;

    request.extraParams['company.id'] = companyId;

    const response = await this.dependencies.api.clients.MaintenanceWindows.readRecords(
      request,
      getRequestDefaultOptions()
    );
    this.response = response;

    return sanitizeObject({
      summary: this.dependencies.translateFn('{itemsCount} items', { itemsCount: response.total }),
      numItems: response.total,
    });
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<GetDataGridItemsResponse> {
    const companyId = this.dependencies.getActiveCompany().companyId;

    let response = this.response;
    if (!response) {
      request.extraParams['company.id'] = companyId;
      response = await this.dependencies.api.clients.MaintenanceWindows.readRecords(
        request,
        getRequestDefaultOptions()
      );
    } else {
      this.response = null;
    }

    return sanitizeObject({ rawEvents: response.data });
  }

  async setFilters(request: SetFiltersRequest): Promise<{} | undefined> {
    return;
  }

  // this function should exist empty because of error if missing
  async updateSettings(params: UpdateSettingsRequest<Column>): Promise<UpdateSettingsResponse> {
    return {};
  }
}
